import { useState } from 'react';

import { useAppDispatch } from 'segments/hooks';

import { changeCoachesBookingActiveModal, SelectedBookingCoach } from 'features/coachesBooking';

import { CoachesBookingModals, CoachesBookings } from 'widgets/coachesBooking';


const CoachesBooking = () => {
  const dispatch = useAppDispatch();
  const [selectedBookingCoach, setSelectedBookingCoach] = useState<SelectedBookingCoach>();
  const [selectedBookingId, setSelectedBookingId] = useState<number>();

  const handleBookingClick = (coachInfo: SelectedBookingCoach) => {
    setSelectedBookingCoach(coachInfo);
    dispatch(changeCoachesBookingActiveModal('booking-coach-modal'));
  };

  const handleDetailClick = (courtId: number) => {
    setSelectedBookingId(courtId);
    dispatch(changeCoachesBookingActiveModal('booked-coach-detail-modal'));
  };

  return (
    <div>
      <CoachesBookings
        handleBooking={handleBookingClick}
        handleCheckDetail={handleDetailClick}
      />
      <CoachesBookingModals
        selectedCoachBooking={selectedBookingCoach}
        selectedBookingId={selectedBookingId}
      />
    </div>
  );
};

export default CoachesBooking;
